import "./ContactInfoCardComponent.scss";
import CardComponent from "../../../shared/components/card/CardComponent";
import {ImageConfig} from "../../../constants";
import {CommonService} from "../../../shared/services";

interface ContactInfoCardProps {
    phoneNumber: string;
    className?: string;
}

const ContactInfoCardComponent = (props: ContactInfoCardProps) => {
    const {phoneNumber, className} = props;
    return (
        <div className={`contact-info-card ${className}`}>
            <CardComponent>
                <div className="contact-info-card__content ">
                    For any questions or concerns, please <br/>contact us at:
                </div>
                <div className={'phone-number-wrapper'}>
                    <div>
                        <ImageConfig.PhoneIcon/>
                    </div>

                    <div className={'phone-number'}>
                        {CommonService.formatPhoneNumber(phoneNumber)}
                    </div>
                </div>
            </CardComponent>
        </div>
    )
};

export default ContactInfoCardComponent;



